(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    const retailRequests = new Map();
async function getRetailProduct(url) {
  const previous = retailRequests.get(url);
  if (previous && Date.now() - previous.time < 30000) return previous.promise;
  const promise = fetch(url, { credentials: 'omit', cache: 'no-store', headers: { Accept: 'application/json' } })
    .then(response => {
      if (!response.ok) throw new Error('Retail price unavailable');
      return response.json();
    });
  retailRequests.set(url, { time: Date.now(), promise });
  promise.catch(() => retailRequests.delete(url));
  return promise;
}
class B2BRetailPrice extends HTMLElement {
  async connectedCallback() {
    this.hidden = true;
    try {
      const product = await getRetailProduct(this.dataset.url);
      if (!this.isConnected) return;
      const variant = product.variants?.find(item => String(item.id) === this.dataset.variantId);
      const retail = Number(variant?.price);
      const business = Number(this.dataset.businessPrice);
      if (!Number.isSafeInteger(retail) || retail <= business || Math.round(retail * 0.9) !== business) return;
      this.querySelector('[data-retail-amount]').textContent = new Intl.NumberFormat(
        this.dataset.locale || 'de-DE', { style: 'currency', currency: this.dataset.currency }
      ).format(retail / 100);
      this.hidden = false;
    } catch {
      this.hidden = true;
    }
  }
}
if (!customElements.get('b2b-retail-price')) customElements.define('b2b-retail-price', B2BRetailPrice);
  } catch(e) { console.error(e); }
})();

})();
